import React from 'react';

import { Divider } from 'components';
import { SecurityUser } from 'iconsax-react';

import { superAdminOrganizationUrl, superAdminUrl } from 'constants/url';

import { NavigationItems } from 'types/app';

import { palette } from 'styles/theme';

export const SuperAdminItems = (organizationId?: string): NavigationItems[] => [
  { component: <Divider sx={{ margin: '0.5rem 0' }} /> },
  {
    id: 'menu-super-admin',
    url: () =>
      organizationId
        ? superAdminOrganizationUrl(organizationId)
        : superAdminUrl(),
    text: 'Administration',
    icon: (
      <SecurityUser variant="TwoTone" color={palette.whiteText} size="20" />
    ),
  },
];
